import { render } from "./DocumentsStatutsReglements.vue?vue&type=template&id=25959c48"
import script from "./DocumentsStatutsReglements.vue?vue&type=script&lang=js"
export * from "./DocumentsStatutsReglements.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__